

import request from '@/utils/request.js'
// 登录
export function login (data) {
  return request({
    url: 'index.php?a=sxadmin&b=login&c=login',
    method: 'post',
    data
  })
}
//校验密码强度
export function checkWeakPassword (data) {
  return request({
    url: 'index.php?a=sxadmin&b=index&c=checkWeakPassword',
    method: 'post',
    data
  })
}
//获取当前登录用户基本信息
export function getMemberInfo (data) {
  return request({
    url: 'index.php?a=sxadmin&b=member&c=getMemberInfo',
    method: 'post',
    data
  })
}
//岗位列表
export function getPostList (data) {
  return request({
    url: 'index.php?a=sxadmin&b=post&c=getPostList',
    method: 'post',
    data
  })
}
//岗位列表
export function postSave (data) {
  return request({
    url: 'index.php?a=sxadmin&b=post&c=save',
    method: 'post',
    data
  })
}
//岗位列表
export function postDelete (data) {
  return request({
    url: 'index.php?a=sxadmin&b=post&c=delete',
    method: 'post',
    data
  })
}

//职务级别列表
export function levelgetLevelList (data) {
  return request({
    url: 'index.php?a=sxadmin&b=level&c=getLevelList',
    method: 'post',
    data
  })
}

//职务级别详情
export function levelgetInfo (data) {
  return request({
    url: 'index.php?a=sxadmin&b=level&c=getInfo',
    method: 'post',
    data
  })
}
//职务级别新增
export function levelsave (data) {
  return request({
    url: 'index.php?a=sxadmin&b=level&c=save',
    method: 'post',
    data
  })
}

//职务级别删除
export function leveldelete (data) {
  return request({
    url: 'index.php?a=sxadmin&b=level&c=delete',
    method: 'post',
    data
  })
}
//查看工作范围的可访问职务级别
export function viewAuthLevel (data) {
  return request({
    url: 'index.php?a=sxadmin&b=unit&c=viewAuthLevel',
    method: 'post',
    data
  })
}
//获取设置工作范围的选项
export function getWorkRangeOptions (data) {
  return request({
    url: 'index.php?a=sxadmin&b=unit&c=getWorkRangeOptions',
    method: 'post',
    data
  })
}
//设置工作范围
export function saveUnitWorkRange (data) {
  return request({
    url: 'index.php?a=sxadmin&b=unit&c=saveUnitWorkRange',
    method: 'post',
    data
  })
}
//获取系统信息
export function getUnitInfo (data) {
  return request({
    url: 'index.php?a=sxadmin&b=unit&c=getUnitInfo',
    method: 'post',
    data
  })
}
//更新单位信息

export function saveUnit (data) {
  return request({
    url: 'index.php?a=sxadmin&b=unit&c=saveUnit',
    method: 'post',
    data
  })
}


//获取组织树
export function getOrgTree (data) {
  return request({
    url: 'index.php?a=sxadmin&b=org&c=getOrgTree',
    method: 'post',
    data
  })
}
//获取部门列表
export function getOrgList (data) {
  return request({
    url: 'index.php?a=sxadmin&b=org&c=getOrgList',
    method: 'post',
    data
  })
}

//部门组件接口
export function getArchitectureOption (data) {
  return request({
    url: 'index.php?a=sxadmin&b=common&c=getArchitectureOption',
    method: 'post',
    data
  })
}

//组件人员
export function getMemberOption (data) {
  return request({
    url: 'index.php?a=sxadmin&b=common&c=getMemberOption',
    method: 'post',
    data
  })
}


//组件人员
export function orggetInfo (data) {
  return request({
    url: 'index.php?a=sxadmin&b=org&c=getInfo',
    method: 'post',
    data
  })
}

export function orgsave (data) {
  return request({
    url: 'index.php?a=sxadmin&b=org&c=save',
    method: 'post',
    data
  })
}

export function orgdelete (data) {
  return request({
    url: 'index.php?a=sxadmin&b=org&c=delete',
    method: 'post',
    data
  })
}
//人员管理列表
export function getMemberList (data) {
  return request({
    url: 'index.php?a=sxadmin&b=member&c=getMemberList',
    method: 'post',
    data
  })
}
//人员管理详情
export function membergetInfo (data) {
  return request({
    url: 'index.php?a=sxadmin&b=member&c=getInfo',
    method: 'post',
    data
  })
}
//人员管理添加
export function membersave (data) {
  return request({
    url: 'index.php?a=sxadmin&b=member&c=save',
    method: 'post',
    data
  })
}
//人员管理删除
export function memberdelete (data) {
  return request({
    url: 'index.php?a=sxadmin&b=member&c=delete',
    method: 'post',
    data
  })
}

//组列表
export function groupgetList (data) {
  return request({
    url: 'index.php?a=sxadmin&b=group&c=getList',
    method: 'post',
    data
  })
}
//组详情
export function groupgetInfo (data) {
  return request({
    url: 'index.php?a=sxadmin&b=group&c=getInfo',
    method: 'post',
    data
  })
}
//组新增
export function groupsave (data) {
  return request({
    url: 'index.php?a=sxadmin&b=group&c=save',
    method: 'post',
    data
  })
}

//组新增
export function groupdelete (data) {
  return request({
    url: 'index.php?a=sxadmin&b=group&c=delete',
    method: 'post',
    data
  })
}


//角色列表
export function roleListAjax (data) {
  return request({
    url: 'index.php?a=sxadmin&b=role&c=roleListAjax',
    method: 'post',
    data
  })
}
//角色添加
export function saveRole (data) {
  return request({
    url: 'index.php?a=sxadmin&b=role&c=saveRole',
    method: 'post',
    data
  })
}
//角色删除
export function deleteRole (data) {
  return request({
    url: 'index.php?a=sxadmin&b=role&c=deleteRole',
    method: 'post',
    data
  })
}

//获取角色树状数据
export function getMenuTreeForRole (data) {
  return request({
    url: 'index.php?a=sxadmin&b=role&c=getMenuTreeForRole',
    method: 'post',
    data
  })
}

//获取菜单列表
export function menuListInitAjax (data) {
  return request({
    url: 'index.php?a=sxadmin&b=menu&c=menuListInitAjax',
    method: 'post',
    data
  })
}
//菜单保存
export function saveMenu (data) {
  return request({
    url: 'index.php?a=sxadmin&b=menu&c=saveMenu',
    method: 'post',
    data
  })
}
//菜单删除
export function deleteMenu (data) {
  return request({
    url: 'index.php?a=sxadmin&b=menu&c=deleteMenu',
    method: 'post',
    data
  })
}
//根据id获取菜单信息
export function getMenuById (data) {
  return request({
    url: 'index.php?a=sxadmin&b=menu&c=getMenuById',
    method: 'post',
    data
  })
}
//类型/字典树
export function getTreeMenu (data) {
  return request({
    url: 'index.php?a=sxadmin&b=dictionary&c=getTreeMenu',
    method: 'post',
    data
  })
}
//新增数据字典分类
export function saveCategory (data) {
  return request({
    url: 'index.php?a=sxadmin&b=dictionary&c=saveCategory',
    method: 'post',
    data
  })
}
//新增数据字典
export function saveDictionary (data) {
  return request({
    url: 'index.php?a=sxadmin&b=dictionary&c=saveDictionary',
    method: 'post',
    data
  })
}

//删除数据字典分类
export function deleteCategory (data) {
  return request({
    url: 'index.php?a=sxadmin&b=dictionary&c=deleteCategory',
    method: 'post',
    data
  })
}

//删除数据字典
export function deleteDictionary (data) {
  return request({
    url: 'index.php?a=sxadmin&b=dictionary&c=deleteDictionary',
    method: 'post',
    data
  })
}

//数据字典值列表
export function getDictionaryValueList (data) {
  return request({
    url: 'index.php?a=sxadmin&b=dictionary&c=getDictionaryValueList',
    method: 'post',
    data
  })
}


//新增数据字典值
export function saveDictionaryValue (data) {
  return request({
    url: 'index.php?a=sxadmin&b=dictionary&c=saveDictionaryValue',
    method: 'post',
    data
  })
}
//数据字典值删除
export function deleteDictionaryValue (data) {
  return request({
    url: 'index.php?a=sxadmin&b=dictionary&c=deleteDictionaryValue',
    method: 'post',
    data
  })
}
//角色授权
export function authRole (data) {
  return request({
    url: 'index.php?a=sxadmin&b=role&c=authRole',
    method: 'post',
    data
  })
}
//模板分类
export function getGroupList (data) {
  return request({
    url: 'index.php?a=sxadmin&b=template&c=getGroupList',
    method: 'post',
    data
  })
}
//新增模板
export function saveGroup (data) {
  return request({
    url: 'index.php?a=sxadmin&b=template&c=saveGroup',
    method: 'post',
    data
  })
}
//删除模板
export function delGroup (data) {
  return request({
    url: 'index.php?a=sxadmin&b=template&c=delGroup',
    method: 'post',
    data
  })
}
//模板管理列表
export function templateGetList (data) {
  return request({
    url: 'index.php?a=sxadmin&b=template&c=getList',
    method: 'post',
    data
  })
}
//模板管理新增
export function templateSave (data) {
  return request({
    url: 'index.php?a=sxadmin&b=template&c=save',
    method: 'post',
    data
  })
}
//模板管理详情
export function templateGetInfo (data) {
  return request({
    url: 'index.php?a=sxadmin&b=template&c=getInfo',
    method: 'post',
    data
  })
}

//模板管理删除
export function templateDelete (data) {
  return request({
    url: 'index.php?a=sxadmin&b=template&c=delete',
    method: 'post',
    data
  })
}













// WEBPACK FOOTER //
// ./src/api/common.js